<app-header></app-header>

<div class="row h100 exhibitor-backoffice">
  <div class="col-12 col-lg-2 h100 exhibitor-backoffice__left">
    <app-menu-exhibitor [active]="'exhibitors'"></app-menu-exhibitor>
  </div>
  <div class="col-12 col-lg-10 exhibitor-backoffice__right">

    <app-menu-product-sub-menu [active]="'detail'" [product]="exhibitorData['product']"></app-menu-product-sub-menu>

    <div class="exhibitor-backoffice__content">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'active': activeTab === 1 }" [ngStyle]="{ 'color': activeTab === 1 ? catalogueService.getProperty('mainColor') : '#222222', 'border-bottom-color': activeTab === 1 ? catalogueService.getProperty('mainColor') : 'transparent'  }" href="javascript:void(0)" (click)="setTab(1)">
            {{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.BASIC_INFORMATION' | translate }}
          </a>
        </li>
        <li class="nav-item" *ngIf="productId">
          <a class="nav-link" [ngClass]="{ 'active': activeTab === 2 }" [ngStyle]="{ 'color': activeTab === 2 ? catalogueService.getProperty('mainColor') : '#222222', 'border-bottom-color': activeTab === 2 ? catalogueService.getProperty('mainColor') : 'transparent'  }" href="javascript:void(0)" (click)="setTab(2)">
            {{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.MULTIMEDIA' | translate }}
          </a>
        </li>
        <li class="nav-item" *ngIf="productId && isCategoriesActive">
          <a class="nav-link" [ngClass]="{ 'active': activeTab === 3 }" [ngStyle]="{ 'color': activeTab === 3 ? catalogueService.getProperty('mainColor') : '#222222', 'border-bottom-color': activeTab === 3 ? catalogueService.getProperty('mainColor') : 'transparent'  }" href="javascript:void(0)" (click)="setTab(3)">
            {{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.CATEGORIES' | translate }}
          </a>
        </li>
      </ul>
      <form name="form" class="form" #form="ngForm">

        <div [hidden]="activeTab !== 1">
          <app-translated-fields [exhibitorData]="exhibitorData" [eventName]="eventName" [hasName]="true" (defaultLangValid)="onDefaultLangValidityChange($event)"></app-translated-fields>
        </div>

        <div [hidden]="activeTab !== 2">
          <app-edit-product-multimedia [exhibitorData]="exhibitorData"></app-edit-product-multimedia>
        </div>

        <div *ngIf="isCategoriesActive" [hidden]="activeTab !== 3">
          <app-edit-products-categories [exhibitorData]="exhibitorData"></app-edit-products-categories>
        </div>

        <div class="row">
          <div class="col">
            <button type="button" class="btn btn--submit float-end" (click)="saveBtn()" [disabled]="!form.valid || !isDefaultLangValid" [style.background-color]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')">
              <span *ngIf="productId">{{ 'COMMON.SAVE' | translate }}</span>
              <span *ngIf="!productId">{{ 'COMMON.CONTINUE' | translate }}</span>
            </button>
            <button type="button" class="btn btn--light float-end mx-sm-3" (click)="cancel()">
              {{ 'COMMON.CANCEL' | translate }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<app-footer></app-footer>
